export default obj => obj.edges.map(edge => edge.node);



// WEBPACK FOOTER //
// ./src/helpers/mapNodes.js